export default "__VITE_ASSET__3e53b184__"